export const GALLERY_PAGE_SIZE = 24;
